import {
  createRefreshSyncRegistry,
  type RefreshSyncRegistry,
} from 'features/rolodex/extensionFunctions/entriesWithSyncedRefreshes/internal/providers/createRefreshSyncRegistry'
import React from 'react'

// MAINTAINER-CONTRACT.IfChange:
// This provider's boundary, context contract, or missing-provider behavior
// changes.
// MAINTAINER-CONTRACT.ThenChange(src/features/rolodex/extensionFunctions/entriesWithSyncedRefreshes/README.md)
// MAINTAINER-CONTRACT.ThenChange(src/features/rolodex/extensionFunctions/entriesWithSyncedRefreshes/internal/UseRolodexEntriesWithSyncedRefreshes.test.tsx)

export function RolodexEntriesWithSyncedRefreshesProvider({
  children,
}: RolodexEntriesWithSyncedRefreshesProviderProps): React.ReactElement {
  const refreshSyncRegistry = React.useMemo(
    () => createRefreshSyncRegistry(),
    []
  )

  return (
    <RefreshSyncRegistryContext.Provider value={refreshSyncRegistry}>
      {children}
    </RefreshSyncRegistryContext.Provider>
  )
}

// ----------------------------------------------------------------------------
//                                Helper Fns
// ----------------------------------------------------------------------------

export function useRolodexRefreshSyncRegistry(): RefreshSyncRegistry {
  const refreshSyncRegistry = React.useContext(RefreshSyncRegistryContext)

  if (!refreshSyncRegistry) {
    throw new Error(
      'useRolodexEntriesWithSyncedRefreshes must be used within a RolodexEntriesWithSyncedRefreshesProvider'
    )
  }

  return refreshSyncRegistry
}

const RefreshSyncRegistryContext =
  React.createContext<RefreshSyncRegistry | null>(null)

// ----------------------------------------------------------------------------
//                                Helper Types
// ----------------------------------------------------------------------------

export interface RolodexEntriesWithSyncedRefreshesProviderProps {
  children: React.ReactNode
}
